export const isUndefined = (value: unknown) => {
  return value === undefined;
};

export const hasNoProperties = (value: object | null | undefined): boolean => {
  if (value == null) return true;
  for (const key in value) {
    if (Object.prototype.hasOwnProperty.call(value, key)) return false;
  }
  return true;
};

export const checkFeaturreEnabled = (
  featuresJson: string | undefined,
  featureKey: string
): boolean => {
  if (!featuresJson) return false;
  try {
    const features = JSON.parse(featuresJson);
    return !!features[featureKey];
  } catch (error) {
    console.error('Error parsing features JSON:', error);
    return false;
  }
};

export const checkSelfAssessmentTemplateEnabled = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  features: Record<string, any> | null,
  templateKey: string | null
): boolean => {
  if (!features) return false;
  try {
    return (
      Array.isArray(features.selfAssessmentTemplateKeys) &&
      features.selfAssessmentTemplateKeys.includes(templateKey)
    );
  } catch (error) {
    console.error('Error parsing features JSON:', error);
    return false;
  }
};

export const validateFloatInput = (value: string): boolean => {
  const floatRegex = /^-?\d*(\.\d+)?$/;
  return floatRegex.test(value);
};

export const formatFloatInput = (input: string): string => {
  // Replace comma with dot
  let formatted = input.replace(',', '.');

  // Remove invalid characters (allow digits, dot, and minus)
  formatted = formatted.replace(/[^0-9.-]/g, '');

  // Ensure only one dot
  const parts = formatted.split('.');
  if (parts.length > 2) {
    formatted = parts[0] + '.' + parts.slice(1).join('');
  }

  // Ensure only one leading minus sign
  formatted = formatted.replace(/(?!^)-/g, ''); // remove any '-' not at start

  return formatted;
};

export const getBarColor = (percentage: number): string => {
  if (percentage < 30) return '#ef4444';
  if (percentage < 60) return '#f59e0b';
  return '#22c55e';
};

export const getFileName = (path?: string | File) => {
  if (!path) return '';
  if (path instanceof File) {
    return path.name;
  }
  const parts = path.split('/');
  return parts[parts.length - 1] || '';
};

export const getAssessmentTotalScore = (
  total_score?: number,
  max_score?: number
) => {
  return max_score && max_score > 0 && total_score !== undefined
    ? Number(((total_score / max_score) * 100).toFixed(1))
    : 0;
};

export function htmlToPreviewText(html: string, maxLength = 100): string {
  if (!html) return '';

  // Strip HTML using the browser (safe & reliable)
  const div = document.createElement('div');
  div.innerHTML = html;
  const text = div.textContent || div.innerText || '';

  // Normalize whitespace
  const normalized = text.replace(/\s+/g, ' ').trim();

  // Truncate
  return normalized.length > maxLength
    ? normalized.slice(0, maxLength) + '…'
    : normalized;
}

export const sanctionScreeningStatusMap: Record<
  string,
  { label: string; color: string }
> = {
  clear: { label: 'Clear', color: 'green' },
  not_screened: { label: 'Not Screened', color: 'gray' },
  flagged: { label: 'Flagged', color: 'red' },
  watchlist: { label: 'Watchlist', color: 'orange' },
  pending: { label: 'Pending', color: 'blue' },
  error: { label: 'Error', color: 'red' },
};

export const tierOneSuppliersAssessmentMap: Record<
  string,
  { label: string; color: string }
> = {
  unknown: { label: 'Unknown', color: 'gray' },
  identified: { label: 'Identified', color: 'yellow' },
  risk_assessed: { label: 'Risk Assessed', color: 'blue' },
  verified: { label: 'Verified', color: 'green' },
};

export const tierTwoSuppliersAssessmentMap: Record<
  string,
  { label: string; color: string }
> = {
  none: { label: 'No Visibility', color: 'gray' },
  critical_only: { label: 'Critical Path Only', color: 'yellow' },
  partial: { label: 'Partial Mapping (~50%)', color: 'blue' },
  full: { label: 'Full Transparency', color: 'green' },
};
